import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/model/loadedModel.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createEvent, createStore } from 'effector';
var resetLoadedModels = createEvent('reset', {
  name: "resetLoadedModels",
  sid: "-epkztz"
});
/**
 * Загруженные модели и их статусы
 */

var updateLoadedModels = createEvent({
  name: "updateLoadedModels",
  sid: "-aebpaj"
});
var removeLoadedModel = createEvent({
  name: "removeLoadedModel",
  sid: "-h1a1z7"
});
var loadedModels$ = createStore({}, {
  name: "loadedModels$",
  sid: "-h5cch7"
}).on(updateLoadedModels, function (data, _ref) {
  var urn = _ref.urn,
      status = _ref.status;
  return _objectSpread(_objectSpread({}, data), {}, _defineProperty({}, urn, status));
}).on(removeLoadedModel, function (data, _ref2) {
  var urn = _ref2.urn;

  var newData = _objectSpread({}, data);

  delete newData[urn];
  return newData;
}).reset(resetLoadedModels);
export { resetLoadedModels, updateLoadedModels, loadedModels$, removeLoadedModel };